// extracted by css-extract-rspack-plugin
export default {"card":"e1XY1qw9Pki8Kx1h","default":"g6ggU3DZrlgbC4Rt","compact":"kKZqLOCh70Izm3uv","destructive":"dkf75U6xEwrdb3Hm","edgy":"Ea7NCEL6_O8XXGqf"};